import { Component, OnInit } from "@angular/core";
import { Location } from "@angular/common";
import { ActivatedRoute } from "@angular/router";
import { ApiService } from "./../../services/api";

// External
import { AngularFireDatabase } from "angularfire2/database";
import * as lodash from "lodash";
import { timeout } from "rxjs/operators";
import { MatSnackBar } from "@angular/material";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from "@angular/forms";
// import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { FormsService } from "app/services/forms";
import { async } from "@angular/core/testing";

@Component({
  templateUrl: "./offer.detail.component.html",
})
export class OfferDetailComponent implements OnInit {
  public orders: any = [];
  public nextKey: any;
  public prevKeys: Array<any>;
  private offsetOrders: number;
  public offer: any;
  public imageLoader = true;
  private postId: string;
  private author: string;
  public totalAmount = 0;
  public commission = 0.1;
  public totalAmountPaid = 0;
  public skus: Array<any>;
  public isVariantEdit = false;
  public form: FormGroup;
  public goLive = false;
  public user: any = {};
  public goLiveToggle = false;
  constructor(
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private location: Location,
    public snackBar: MatSnackBar,
    public formsService: FormsService,
    private fireDatabase: AngularFireDatabase,
    private apiService: ApiService
  ) {
    this.prevKeys = [];
    this.offsetOrders = 20;
  }

  async ngOnInit() {
    this.author = this.route.snapshot.paramMap.get("author");
    this.postId = this.route.snapshot.paramMap.get("id");
    this.form = this.formBuilder.group({
      goLive: this.goLive,
    });
    if (this.author && this.postId) {
      this.initData();
    }
    this.getOffers();
    this.getLiveData();
  }
  getOffers(startKey?: any) {
    const fireList = this.fireDatabase
      .list(`/offer-orders/${this.postId}`)
      .subscribe(
        async (result) => {
          this.orders = [];

          this.nextKey = lodash.get(result[this.offsetOrders], "$key");
          lodash.forEach(result, async (item, key) => {
            if (item) {
              if (item.payment) {
                if (item.payment.paymentStatus) {
                  console.log(item);
                  this.totalAmount += item.payment.amount;
                  item.isSelected = false;
                  let user = await this.apiService
                    .object("/users/" + item.uid)
                    .then((response) => JSON.parse(JSON.stringify(response)));
                  item.email = user.email ? user.email : "N/A";
                  item.name = user.username
                    ? user.username
                    : user.fullName
                    ? user.fullName
                    : "N/A";
                  item.fullName = user.fullName ? user.fullName : "N/A";
                  this.orders.push(item);
                  this.totalAmountPaid += this.totalAmount * 0.1;
                }
              }
            }
          });
          if (fireList) fireList.unsubscribe();
          this.imageLoader = false;
          try {
            this.user = await this.apiService.object(
              `users/${this.offer.uid}`
            );
            let profile = await this.apiService.object(
              "user-profiles/" + this.offer.userId + "/" + this.author
            );
            this.user.profile = profile;
          } catch (error) {
            console.log(error);
          }
        },
        (error) => {
          console.error(error);
        }
      );
  }

  goNext() {
    this.prevKeys.push(lodash.first(this.orders)["$key"]);
    this.getOffers(this.nextKey);
  }

  goPrev() {
    const prevKey = lodash.last(this.prevKeys);
    this.prevKeys = lodash.dropRight(this.prevKeys);
    this.getOffers(prevKey);
  }
  public initData() {
    this.fireDatabase
      .object(`/user-offers/${this.author}/${this.postId}`)
      .subscribe((result) => {
        console.log(result);

        result.isStockUnlimited = result.isStockUnlimited ? true : false;
        this.offer = result;
        // console.log(this.offer.goLive);
        this.form.controls.goLive.setValue(this.offer.goLive);
        this.goLiveToggle = this.offer.goLive;
        if (!this.offer.images) {
          this.offer.images = [this.offer.image];
        }
        if (this.offer.offerType == 2 && this.offer.skus) {
          this.skus = [];
          for (let s = 0; s < this.offer.skus.length; s++) {
            let sku = this.offer.skus[s];
            sku.varients = [];
            if (sku.variantCombinations) {
              lodash.forEach(sku.variantCombinations, (option, value) => {
                if (this.offer.varientOptions[value]) {
                  if (this.offer.varientOptions[value].values[option]) {
                    sku.varients.push({
                      option: this.offer.varientOptions[value].name,
                      value: this.offer.varientOptions[value].values[option]
                        .name,
                    });
                  }
                }
              });
            }
            this.skus.push(sku);
          }
        }
      });
  }
  public back() {
    this.location.back();
  }

  public payToAll() {
    if (confirm("Are you sure? you want to pay all orders amount.")) {
      const amount = 0;
      const req = {
        offerId: this.postId,
        paytime: new Date().getTime() / 1000,
        amount: amount,
        status: false,
        orders: [],
        cid: this.author,
      };
      lodash.forEach(this.orders, (item, key) => {
        if (item.payment) {
          if (item.payment.paymentStatus) {
            req.amount += item.payment.amount;
            req.orders[item.$key] = true;
          }
        }
      });
      setTimeout(() => {
        //    console.log(req)
        this.apiService.push(`club-transactions/${this.author}`, req);
      }, 400);
    }
  }
  public pay() {
    if (confirm("Are you sure? you want to pay.")) {
      const amount = 0;
      const req = {
        offerId: this.postId,
        paytime: new Date().getTime() / 1000,
        amount: amount,
        status: false,
        orders: [],
        cid: this.author,
      };
      lodash.forEach(this.orders, (item, key) => {
        if (item.isSelected && item.payment.paymentStatus) {
          req.amount += item.payment.amount;
          req.orders[item.$key] = true;
        }
      });
      setTimeout(() => {
        if (amount > 0) {
          this.apiService.push(`club-transactions/${this.author}`, req);
        }
      }, 400);
    }
  }
  public onEdit() {
    this.isVariantEdit = true;
  }
  removeSku(index) {
    this.skus.splice(index, 1);
  }
  public onVariantSave() {
    for (let p = 0; p < this.skus.length; p++) {
      delete this.skus[p].varients;
    }
    this.apiService
      .set(`/user-offers/${this.author}/${this.postId}/skus`, this.skus)
      .then((res) => {
        console.log(res);

        this.snackBar.open("Skus updated successfully!!", "OK!", {
          duration: 3000,
        });
        this.isVariantEdit = false;
      });
  }

  async isLiveChange($event) {
    console.log($event);

    try {
      let stroryId = this.apiService.getKey("server-process/user-story");
      if ($event == true) {
        this.form.value.goLive = true;
        let data = await this.apiService.set(
          `/user-offers/${this.author}/${this.postId}/goLive`,
          true
        );
        await this.apiService.set(
          `/user-offers/${this.author}/${this.postId}/userStoryId`,
          stroryId
        );

        this.form.value.storyProductId = this.postId;
        this.form.value.authorId = this.author;
        this.form.value.type = 3;
        if (this.offer.isAdmin) {
          this.form.value.isAdmin = true;
        }
        console.log(this.offer, this.form.value);

        let newdata = await this.apiService.set(
          `server-process/user-story/${stroryId}`,
          this.form.value
        );
      } else if ($event == false) {
        this.form.value.goLive = false;

        this.form.value.storyProductId = this.postId;
        this.form.value.authorId = this.author;
        this.form.value.type = 3;
        if (this.offer.isAdmin) {
          this.form.value.isAdmin = true;
          this.updateUserStories();
          let newdata = await this.apiService.update(
            `/user-offers/${this.author}/${this.postId}/`,
            this.form.value
          );
        }
        await this.apiService.set(`server-process/user-story/${stroryId}`, {
          ...this.form.value,
          isDeleted: true,
          storyProductId: this.postId,
          type: 3,
          authorId: this.author,
        });
        let newdata = await this.apiService.update(
          `/user-offers/${this.author}/${this.postId}/`,
          this.form.value
        );
        await this.apiService.set(
          `/user-offers/${this.author}/${this.postId}/goLive`,
          false
        );
        this.updateUserStories();
      }
    } catch (error) {}
  }
  async isLive(event) {
    console.log(this.form.value.goLive);

    // try {
    //   let stroryId = this.apiService.getKey("server-process/user-story");
    //   if (!this.form.value.goLive) {
    //     this.form.value.goLive = true;
    //     let data = await this.apiService.set(
    //       `/user-offers/${this.author}/${this.postId}/goLive`,
    //       true
    //     );
    //     await this.apiService.set(
    //       `/user-offers/${this.author}/${this.postId}/userStoryId`,
    //       stroryId
    //     );

    //     this.form.value.storyProductId = this.postId;
    //     this.form.value.authorId = this.author;
    //     this.form.value.type = 3;
    //     if (this.offer.isAdmin) {
    //       this.form.value.isAdmin = true;
    //     }
    //     console.log(this.offer, this.form.value);

    //     let newdata = await this.apiService.set(
    //       `server-process/user-story/${stroryId}`,
    //       this.form.value
    //     );
    //   } else if (this.form.value.goLive == true) {
    //     this.form.value.goLive = false;
    //     if (this.offer.isAdmin) {
    //       this.form.value.isAdmin = true;
    //       this.updateUserStories();
    //       let newdata = await this.apiService.update(
    //         `/user-offers/${this.author}/${this.postId}/`,
    //         this.form.value
    //       );
    //     }
    //     await this.apiService.set(`server-process/user-story/${stroryId}`, {
    //       ...this.form.value,
    //       isDeleted: true,
    //     });
    //     let newdata = await this.apiService.update(
    //       `/user-offers/${this.author}/${this.postId}/`,
    //       this.form.value
    //     );
    //     await this.apiService.set(
    //       `/user-offers/${this.author}/${this.postId}/goLive`,
    //       false
    //     );
    //     this.updateUserStories();
    //   }
    // } catch (error) {}
  }
  async getLiveData() {
    try {
      let data = await this.apiService.list(
        `/user-offers/${this.author}/${this.postId}/`
      );
      console.log(data);
    } catch (error) {}
  }
  async updateUserStories() {
    try {
      let data = await this.apiService.list(`/user-stories/${this.author}/`);
      console.log(data);
      for (let i = 0; i < data.length; i++) {
        const element = data[i];
        if (element.storyProductId === this.postId) {
          console.log(element["$key"]);
          const a = element["$key"];
          let newdata = await this.apiService.set(
            `/user-stories/${this.author}/` + a,
            null
          );
        }
      }
    } catch (error) {}
  }

  exportOrders() {
    let jsonData: Array<any> = [];
    this.orders.map((x, index) => {
      let d = new Date(x.orderTime * 1000);
      let map = {
        "Order ID": x.code,
        "Customer Name": x.userName && x.userName != "" ? x.userName : x.name,
        "Customer Full Name": x.fullName,
        "Customer Email": x.email,
        Quantity: x.quantity,
        Date: `${d.getDate()}-${d.getMonth() + 1}-${d.getFullYear()}`,
        Amount: parseFloat(x.payment.amount).toFixed(2),
        Status: x.payment.paymentStatus == true ? "Paid" : "Unpaid",
      };
      jsonData.push(map);
    });
    this.downloadFile(jsonData.reverse(), "order-list");
  }

  ConvertToCSV(objArray, headerList) {
    let array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
    let str = "";
    let row = "S.No,";

    for (let index in headerList) {
      row += headerList[index] + ",";
    }
    row = row.slice(0, -1);
    str += row + "\r\n";
    for (let i = 0; i < array.length; i++) {
      let line = i + 1 + "";
      for (let index in headerList) {
        let head = headerList[index];

        line += "," + array[i][head];
      }
      str += line + "\r\n";
    }
    return str;
  }
  downloadFile(data, filename = "data") {
    let csvData = this.ConvertToCSV(data, [
      "Order ID",
      "Customer Name",
      "Customer Full Name",
      "Customer Email",
      "Quantity",
      "Date",
      "Amount",
      "Status",
    ]);
    console.log(csvData);
    let blob = new Blob(["\ufeff" + csvData], {
      type: "text/csv;charset=utf-8;",
    });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser =
      navigator.userAgent.indexOf("Safari") != -1 &&
      navigator.userAgent.indexOf("Chrome") == -1;
    if (isSafariBrowser) {
      dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }
}
